/* Ficha de producto: la descripción se muestra como desplegable "Opis produktu", con el mismo estilo que el resto */
(function () {
  document.documentElement.classList.add('cm-js');
  function run() {
    document.querySelectorAll('.pp-desc:not(.cm-done)').forEach(function (box) {
      box.classList.add('cm-done');
      var body = box.querySelector('.pp-desc__body');
      if (!body) { box.remove(); return; }
      var det = document.createElement('details');
      det.className = 'accordion pp-acc cm-desc-acc';
      var sum = document.createElement('summary');
      sum.innerHTML = 'Opis produktu <svg class="icon icon--chevron" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      var inner = document.createElement('div');
      inner.className = 'accordion__body rte';
      inner.innerHTML = body.innerHTML;
      det.appendChild(sum);
      det.appendChild(inner);
      if (box.hasAttribute('data-shopify-editor-block')) det.setAttribute('data-shopify-editor-block', box.getAttribute('data-shopify-editor-block'));
      box.replaceWith(det);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
